import React from 'react';
import { Link } from 'react-router-dom';
import { AppSettings } from './../../config/app-settings.js';
import { slideToggle } from './../../composables/slideToggle.js';

function SidebarProfile() {
	function handleProfileExpand(e) {
		e.preventDefault();

		var targetSidebar = document.querySelector('.app-sidebar:not(.app-sidebar-end)');
		var targetMenu = e.target.closest('.menu-profile');
		var targetProfile = document.querySelector('#appSidebarProfileMenu');
		var expandTime = (targetSidebar && targetSidebar.getAttribute('data-disable-slide-animation')) ? 0 : 250;

		if (targetProfile) {
			if (targetProfile.style.display === 'block') {
				targetMenu.classList.remove('active');
			} else {
				targetMenu.classList.add('active');
			}
			slideToggle(targetProfile, expandTime);
			targetProfile.classList.toggle('expand');
		}
	}
  
	return (
		<AppSettings.Consumer>
			{({appSidebarMinify}) => (
					<div className="menu-profile position-relative">
						<a href="#/" onClick={handleProfileExpand} className="menu-link">
							<div className="menu-profile-cover with-shadow"></div>
							<div className="menu-profile-image">
								<img src="/color-admin/admin/react/assets/img/user/profile.jpg" className="object-fit-cover w-100 h-100" alt="" />
							</div>
							<div className="menu-profile-info">
								<div className="d-flex align-items-center">
									<div className="flex-grow-1">
										Sean Ngu
									</div>
									<div className="menu-caret ms-auto"></div>
								</div>
								<small>Frontend developer</small>
							</div>
						</a>
						<div id="appSidebarProfileMenu" className="dropdown-menu w-100 mt-1">
							<Link to="/settings" className="dropdown-item d-flex align-items-center gap-2 py-2"><i className="fa fa-cog fs-4 opacity-5"></i><div className="flex-fill">Settings</div></Link>
							<Link to="/profile" className="dropdown-item d-flex align-items-center gap-2 py-2"><i className="fa fa-user fs-4 opacity-5"></i><div className="flex-fill">Edit Profile</div></Link>
							<Link to="/helper" className="dropdown-item d-flex align-items-center gap-2 py-2"><i className="fa fa-question-circle fs-4 opacity-5"></i><div className="flex-fill">Helps</div></Link>
						</div>
				</div>
			)}
		</AppSettings.Consumer>
	)
}

export default SidebarProfile;
